import React, { useState, useEffect } from 'react';
import Classes from '../MainLayout.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import sessionstorage from 'sessionstorage';
import { authActions } from '../../../../redux-store';
import { useSelector } from 'react-redux';
import { DashboardIcon, SettingsIcon, LogoutIcon, MeetingsIcon, MessageIcon, ProfileIcon, CalenderIcon, TeamIcon, Team2MembersIcon, InvoiceIcon, Location2Icon, UserTieIcon, AvailabilityIcon } from '../../../../utils/Icons';

export default function Sidebar({
    isMobile,
    setopenMobileSidebar,
}) {
    const navigateTo = useNavigate();
    const location = useLocation();
    const { pathname } = useLocation();
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.auth);
    const onBoarding = useSelector((state) => state.companyInfo.info);
    const companyId = onBoarding?._id;
    const userId = user?._id;

    const [activePage, setActivePage] = useState(location.pathname);

    useEffect(() => {
        setActivePage(location.pathname);
    }, [location.pathname]);

    const handleLogout = async () => {
        localStorage.clear();
        sessionstorage.clear();
        navigateTo('/');
        await dispatch(authActions.logout());
    };

    const handleNavigate = (page) => {
        navigateTo(page);
        if (isMobile) {
            setopenMobileSidebar(false);
        }
    };

    return (
        <aside className={Classes.sidebar}>
            <div>
                <div className={Classes.logo} onClick={()=>navigateTo('/home')} style={{cursor:"pointer"}}>
                    <img src='/assets/images/logo.webp' alt='logo' draggable={false} />
                </div>
                <nav className={Classes.navMenu}>
                    <h5>ACTIVITY</h5>
                    <ul>
                        <li
                            onClick={() => handleNavigate('/')}
                            className={activePage === '/' ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <DashboardIcon height='17px' fill={activePage === '/' ? 'var(--primary-color)' : 'black'} />
                            </div>
                            Dashboard
                        </li>
                        <li
                            onClick={() => handleNavigate('/messages')}
                            className={activePage === '/messages' ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <MessageIcon height='17px' fill={activePage === '/messages' ? 'var(--primary-color)' : 'black'} />
                            </div>
                            Messages
                        </li>
                        <li
                            onClick={() => handleNavigate('/clients')}
                            className={['/clients', '/add-client'].includes(activePage) ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <Team2MembersIcon height='20px' fill={['/clients', '/add-client'].includes(activePage) ? 'var(--primary-color)' : 'black'} />
                            </div>
                            Clients
                        </li>
                        <li
                            onClick={() => handleNavigate('/appointments')}
                            className={['/appointments', '/add-appointment'].includes(activePage) ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <CalenderIcon height='17px' fill={['/appointments', '/add-appointment'].includes(activePage) ? 'var(--primary-color)' : 'black'} />
                            </div>
                            Appointments
                        </li>
                        <li
                            onClick={() => handleNavigate('/invoices')}
                            className={['/invoices', '/add-invoice'].includes(activePage) ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <InvoiceIcon height='22px' fill={['/invoices', '/add-invoice'].includes(activePage) ? 'var(--primary-color)' : 'black'} />
                            </div>
                            Invoices
                        </li>
                        <li
                            onClick={() => handleNavigate('/routes')}
                            className={['/routes'].includes(activePage) ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <Location2Icon height='22px' fill={['/routes'].includes(activePage) ? 'var(--primary-color)' : 'black'} />
                            </div>
                            Routes
                        </li>
                    </ul>
                    <h5>COMPANY</h5>
                    <ul>
                        <li
                            onClick={() => handleNavigate('/information')}
                            className={activePage === '/information' ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <UserTieIcon height='22px' fill={activePage === '/information' ? 'var(--primary-color)' : 'black'} />
                            </div>
                            Information
                        </li>
                        {/* <li
                            onClick={() => handleNavigate('/availability')}
                            className={activePage === '/availability' ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} style={{ paddingLeft: '3px' }} >
                                <AvailabilityIcon height='20px' fill={activePage === '/availability' ? 'var(--primary-color)' : 'black'} />
                            </div>
                            Availability
                        </li> */}
                        <li
                            onClick={() => handleNavigate('/team')}
                            className={activePage === '/team' ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} style={{ paddingLeft: '3px' }} >
                                <TeamIcon height='20px' fill={activePage === '/team' ? 'var(--primary-color)' : 'black'} />
                            </div>
                            Team
                        </li>
                    </ul>
                    <h5>ACCOUNT</h5>
                    <ul>
                        <li
                            onClick={() => handleNavigate('/settings/profile')}
                            className={pathname.startsWith('/settings') ? Classes.navActive : ''}
                        >
                            <div className={Classes.svgIcon} >
                                <SettingsIcon height='17px' fill={pathname.startsWith('/settings') ? 'var(--primary-color)' : 'black'} />
                            </div>
                            Settings
                        </li>
                        <li onClick={handleLogout}>
                            <div className={Classes.svgIcon} >
                                <LogoutIcon height='17px' fill={'black'} />
                            </div>
                            Log Out
                        </li>
                    </ul>
                </nav>
            </div>
        </aside>
    );
}
